const routerTree = {
  //首页
  home: '/home',
  //个人中心
  personCenter: {
    main: '/person-center',
    userInfo:'/person-center/user-info',
    accountActive:'/person-center/account-active',
    myOrder:'/person-center/my-order',
    myInvoice:'/person-center/my-Invoice',
    myCollect:'/person-center/my-collect',
    firmTeam:'/person-center/firm-team',
  },
  //登录
  login:'/login',
}
export default routerTree;